<template>
		<div class="card modal-wrapper p-4 lineItemDetailsModal">
			<div v-if="editingRow">
				<p class="lineItemDetailsTitle">Line Item Details</p>

				<div class="row lineItemRow">
					<div class="col-10">
						<BasicTextInput label="Product Description" type="text" class="my-2" v-model="editingRowData.Description" :disabled="readOnly"/>
					</div>
					<div class="col-2 seq-col">
						<BasicDropdown 
							label="Seq" 
							v-model="editingRowData.dataIndex" 
							:items="seqOptions" 
							style="width: 75px;"
						/>
					</div>
				</div>

				<div class="row lineItemRow">
						<div class="col-2">
							<BasicTextInput label="Qty" type="text" class="my-6" v-model="editingRowData.Quantity" :disabled="readOnly"/>
						</div>
						<div class="col-3">
							<BasicTextInput label="Manufacturer" type="text" class="my-6" v-model="editingRowData.MfgCode" :disabled="readOnly"/>
						</div>
						<div class="col">
							<BasicTextInput label="Manu. Part Number" type="text" class="my-6" v-model="editingRowData.PartNumber" :disabled="readOnly"/>
						</div>
						<div class="col">
							<BasicTextInput label="Dealer Stock Code" type="text" class="my-6" v-model="editingRowData.StockCode" :disabled="readOnly"/>
						</div>
				</div>

				<div class="row lineItemRow">
						<div class="col-4">
							<BasicTextInput label="Retail" type="text" class="my-2" v-model="editingRowData.Retail" :disabled="readOnly"/>
						</div>
						<div class="col-4">
							<BasicTextInput label="Dealer Cost" type="text" class="my-2" v-model="editingRowData.DealerCost" :disabled="readOnly"/>
						</div>
						<div class="col">
							<BasicTextInput label="Disc. A" type="text" class="my-2" v-model="editingRowData.Discount1" :disabled="readOnly"/>
						</div>
						<div class="col">
							<BasicTextInput label="Disc. B" type="text" class="my-2" v-model="editingRowData.Discount2" :disabled="readOnly"/>
						</div>
						<div class="col">
							<BasicTextInput label="GP" type="text" class="my-2" v-model="editingRowData.GPPercent" :disabled="readOnly"/>
						</div>
				</div>

				<div class="row lineItemRow">
						<div class="col-3">
							<BasicTextInput label="Customer Price" type="text" class="my-2" v-model="editingRowData.CustomerCost" :disabled="readOnly" @change="dataChanged" :key="dataUpdateKey"/>
						</div>
						<div class="col">
							<BasicTextInput label="Cust. Disc." type="text" class="my-2" :disabled="true" @change="dataChanged"/>
						</div>
						<div class="col-6">
							<BasicTextInput label="Promotion Code" type="text" class="my-2" :disabled="true"/>
						</div>
					</div>

					<div class="row lineItemRow">
						<div class="col-4">
							<BasicTextInput label="Source" type="text" class="my-2" :disabled="true"/>
						</div>
						<div class="col-3">
							<BasicTextInput label="Line Type" type="text" class="my-2" :disabled="true"/>
						</div>
						<div class="col-5">
							<button id="lineItemSave" @click="saveLineItem" class="btn btn-primary" :disabled="readOnly">Save</button>
						</div>
				</div>
			</div>
		</div>
</template>

<script>
import DescriptionComboboxSearch from './DescriptionComboboxSearch.vue';

export default {
	components: {
		DescriptionComboboxSearch,
	},
	props: {
    editingRow: {
      type: Object,
      default: null,
    },
		editingRowData: {
			type: Object,
			default: null,
		},
		readOnly: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dataUpdateKey: 0,
			seqOptions: []
		};
	},
	mounted() {
		this.data = this.editingRowData;
		this.seqOptions = [];
		for (let index = 0; index < this.data.maxDataIndex; ++index) {
			this.seqOptions.push({
				text: `${index+1}`,
				value: index
			});
		}
	},
	methods: {
		saveLineItem() {
			this.$emit('saveLineItem', this.data.dataIndex);
		},
		dataChanged() {
			this.dataUpdateKey++;
		},
		updateDataValues(data) {
			for (const prop in data) {
				this.editingRowData[prop] = data[prop];
			}

			// TODO: the pricing values are not updating when selecting from the DescriptionComboboxSearch component
			// TODO: Make sure the pricing updates work on a new line - that's where I noticed the problem

			// This line to get the DescriptionComboboxSearch components to update with latest data.
			this.dataUpdateKey++;
		},
		roundToTwoDecimals(data){
      if(Number(data) === 'NaN') return;
      return Number(Number(data).toFixed(2));
    },
	}
}
</script>

<style lang="scss" scoped>
	.lineItemDetailsModal {
		width: 750px!important;
		font-size: 16px!important;
	}

	.lineItemDetailsTitle {
		font-size: 20px!important;
		font-weight: 600;
		text-align: center;
		height: 20px;
		margin-top: -20px;
	}

	.lineItemRow {
		margin-bottom: 10px;
	}

	#lineItemSave {
		margin-top: 30px;
		width: 100px;
		float: right;
	}

	.field-label {
		font-weight: 400;
	}

	.seq-col {
		margin: auto 0;
		left: 40px;
	}

</style>